import { useOktaAuth } from '@okta/okta-react';
import { ReactElement, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingPage from '@/components/shared/LoadingPage';

type RequireAuthProps = {
  children: ReactElement;
};

function RequireAuth({ children }: RequireAuthProps) {
  const { authState, oktaAuth } = useOktaAuth();
  const location = useLocation();

  useEffect(() => {
    if (authState && !authState.isAuthenticated) {
      void oktaAuth.signInWithRedirect();
    }
  }, [authState, oktaAuth, location]);

  if (!authState) {
    return <LoadingPage message='Validating authentication...' />;
  }

  if (!authState.isAuthenticated) {
    return <LoadingPage message='Redirecting to sign in...' />;
  }

  return children;
}

export default RequireAuth;
